import React from "react";
import { openWhitelabel } from "utils/liteapi";

const Deals: React.FC = () => {
  const handleBookHotels = () => {
    openWhitelabel();
  };

  return (
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#1F2937]">Deals</h1>
        <p className="text-sm text-[#6B7280] mt-1">
          Exclusive travel deals for standby travellers.
        </p>
      </div>

      {/* Cards grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Book Hotels card */}
        <button
          type="button"
          onClick={handleBookHotels}
          className="group text-left bg-white rounded-2xl border border-[#E5E7EB] overflow-hidden shadow-sm hover:shadow-lg hover:border-[#FBBF24] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#FBBF24]"
        >
          {/* Banner */}
          <div className="relative h-40 bg-gradient-to-br from-[#1F2937] to-[#111827] flex items-center justify-center">
            <svg
              className="w-16 h-16 text-[#FBBF24] group-hover:scale-110 transition-transform duration-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-3M9 9v.01M9 12v.01M9 15v.01M9 18v.01"
              />
            </svg>
          </div>

          {/* Body */}
          <div className="p-5">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-[#1F2937]">
                Book Hotels
              </h2>
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#FEF3C7] text-[#D97706] group-hover:bg-[#FBBF24] group-hover:text-white transition-colors">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </span>
            </div>
            <p className="text-sm text-[#6B7280] mt-2">
              Search and book hotels worldwide at member rates. Opens our
              booking site in a new tab.
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Deals;
